module.exports = __webpack_public_path__ + "media/כובע.f26f248b.mp3";